import { AppState } from '@redux/store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Section } from '@typesApp/DynamicComponent'
import { OverviewCards, OverviewCardSelection, OverviewInsurerSelection } from '@typesApp/OverviewWidget'
import { Insurer, ProviderType } from '@typesApp/Insurer'
import { getChannelKey, getProviderType } from '@components/Overview/utils/OverviewUtil'
import { getLang } from '@utils/getLang'

// TODO: JSONs to be moved to configurations when ready
import cardHome from '../../__data/base/overview-card-home.json'
import cardInNetwork from '../../__data/base/overview-card-in-network.json'
import cardOutOfNetwork from '../../__data/base/overview-card-out-of-network.json'

type OverviewWidgetState = {
  cards?: OverviewCards
  currentCard?: string
  selectedInsurer?: OverviewInsurerSelection
  cardSelection?: OverviewCardSelection
  hasStore?: boolean
}

const initialState: OverviewWidgetState = {
  cards: {
    home: cardHome.sections as Section[],
    inNetwork: cardInNetwork.sections as Section[],
    outOfNetwork: cardOutOfNetwork.sections as Section[],
  },
  cardSelection: { name: 'home', index: 0 },
}

const REDUCER_PATH = 'overviewWidget'

export const overviewWidgetSlice = createSlice({
  name: REDUCER_PATH,
  initialState: initialState,
  reducers: {
    overviewSetHasStore(state, action: PayloadAction<boolean>) {
      state.hasStore = action.payload
    },
    overviewSetCards(state, action: PayloadAction<OverviewCards>) {
      state.cards = action.payload
      state.cardSelection = {
        name: 'home',
        index: 0,
      }
    },
    overviewSelectInsurer(state, action: PayloadAction<Insurer>) {
      const insurer = action.payload
      const providerType = getProviderType(insurer.availableChannels)

      state.selectedInsurer = {
        id: insurer.id,
        name: insurer.insurerName?.[getLang()],
        providerType,
        channelKey: getChannelKey(insurer.availableChannels, state.hasStore),
        attachment: insurer.attachment,
      }

      state.cardSelection = {
        name: providerType === ProviderType.IN_NETWORK ? 'inNetwork' : 'outOfNetwork',
        index: 1,
      }
    },
    overviewReset(state) {
      state.cardSelection = { name: 'home', index: 0 }
    },
    overviewResetInitialState() {
      return initialState
    },
  },
})

export const {
  overviewReset,
  overviewSetHasStore,
  overviewSetCards,
  overviewSelectInsurer,
  overviewResetInitialState,
} = overviewWidgetSlice.actions

export const overviewCardsSelector = (state: AppState): OverviewCards | undefined => state.overviewWidget.cards
export const overviewCardSelectionSelector = (state: AppState): OverviewCardSelection | undefined =>
  state.overviewWidget.cardSelection
export const overviewSelectedInsurerSelector = (state: AppState): OverviewInsurerSelection | undefined =>
  state.overviewWidget.selectedInsurer
